import { CourseTranslationDTO } from "../domain/models/dto/CourseDTO";
import { ICourseTranslation } from "../domain/models/CourseTranslation";
import { SimpleMapper } from "./SimpleMapper";

export class CourseTranslationMapper extends SimpleMapper<
    ICourseTranslation,
    CourseTranslationDTO
> {
    protected toDTOFields: string[] = [
        "id",
        "courseId",
        "languageCode",
        "title",
        "shortContent",
        "description",
        "author",
        "duration",
        "topic",
        "imageUrl",
    ];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "creatorId",
        "createdAt",
        "updatedAt",
        "updatorId",
    ];
}
